import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { OnCallCentersService, UpdateOnCallCenterBody } from '../../Services/API';
import { MutationKeys, QueryKeys } from '../types';

export const useAddAgenciesToOnCallCenter = (
  extraOptions?: UseMutationOptions<void, AxiosError, UpdateOnCallCenterBody>
) => {
  const queryClient = useQueryClient();

  return useMutation(
    [MutationKeys.addAgenciesToOnCallCenter],
    async (params: UpdateOnCallCenterBody) => {
      return OnCallCentersService.onCallCentersControllerAddAgenciesToOnCallCenter({
        body: params,
      });
    },
    {
      onSuccess: () => {
        toast.success('Les agences ont bien été ajoutées à la permanence');
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchOnCallCenters] });
      },
      onError: (error: AxiosError) => {
        if (error.response?.status === 403) {
          toast.error('Droits insuffisants pour créer des routages');
        } else {
          toast.error("Une erreur est survenue lors de l'ajout des agences à la permanence");
        }
      },
      ...extraOptions,
    }
  );
};
